import React, { memo } from 'react';
import NewEntityFilters from 'containers/components/NewEntityFilters';

import './styles.scss';

const MenuFilters = memo(
    ({
        entity,
        filterKey,
        useQuickFilters,
        useQuickView,
        defaultFilters,
        getCanClearAll,
        clearSpecificFilter,
        defaultQuickFilters,
        readOnlyFilters = [],
        readOnlyQuickFilters = [],
        dontIgnoreTheseFilters = [],
    }) => {
        return (
            <div className="fm-quick-filters-container">
                <NewEntityFilters
                    className="fm-quick-filters"
                    entity={entity}
                    filterKey={filterKey}
                    useQuickFilters={useQuickFilters}
                    useQuickView={useQuickView}
                    defaultFilters={defaultFilters}
                    getCanClearAll={getCanClearAll}
                    clearSpecificFilter={clearSpecificFilter}
                    defaultQuickFilters={defaultQuickFilters}
                    readOnlyFilters={readOnlyFilters}
                    readOnlyQuickFilters={readOnlyQuickFilters}
                    dontIgnoreTheseFilters={dontIgnoreTheseFilters}
                />
            </div>
        );
    },
);

export default MenuFilters;
